<ul class="share_menu">
  <li><a href="https://www.youtube.com/user/971843" target="_blank" class="youtube"></a></li>
  <li><a href="https://www.facebook.com/sefi.bogin" target="_blank" class="facebook"></a></li>
  <li><a href="https://www.linkedin.com/in/sefibogin " target="_blank" class="linkedin"></a></li>
</ul>
